module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAATklEQVQ4y83U0QkAIAgE0IMGcCRXbyQHCC7Dgjbw/Ht+CaeCXwWaNfHK+2UknEtCGEen1S+rsKCgnKxiE5CtXOcYVFDOdGOTkMpN6/y6DTZm3DGOQm23AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI2OjQyKzA5OjAw33rQQQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyNiswOTowMMvnDN4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00001_100x100.png
// module id = Igkn
// module chunks = 0